import { Touchable, WithNativeHTMLProps } from "@kalyzee/kast-web-sdk/web-components";
import React, { ForwardedRef } from "react";

export interface ErrorViewProps extends WithNativeHTMLProps<HTMLDivElement> {
  retry?: () => void;
  message?: string;
  className?: string;
  style?: React.CSSProperties;
}

export interface ErrorViewRef {}

export const ErrorView = React.forwardRef(
  ({ retry, message, className, style, ...nativeProps }: ErrorViewProps, forwardRef: ForwardedRef<ErrorViewRef | undefined>) => {
    return (
      <div {...nativeProps} className={className} style={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: "10px",
        backgroundColor: "#f1efeb",
        ...(style ?? {})
      }}>
        <div style={{
          fontWeight: 700,
          fontSize: "20px",
          lineHeight: "20px",
        }}>{message ?? "Une erreur est apparue."}</div>
        {retry ? (
          <Touchable
          style={{
            padding: "5px 20px",
            borderRadius: "10px",
            fontWeight: 700,
            fontSize: "16px",
            color: "white",
            backgroundColor: "red"
          }}
            onPress={() => {
              retry();
            }}
          >
            Réessayer
          </Touchable>
        ) : null}
      </div>
    );
  }
);
